import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'

export const RowAction = (row: any, setter: Function, setPrint?: Function, fromRequest = false, msg: string = "", canDoAction: boolean = true) => {

    const { t } = useTranslation()

    return (
        <>
            {row?.original?.request?.id || (!fromRequest && row?.original?.id) ?
                <div className={` ${canDoAction ? "pointer" : ""}`}>
                    {
                        row?.original?.isPendingRequest || row?.original?.request?.isPendingRequest ?
                            canDoAction ?
                                <div onClick={() => setter(row?.original || row?.original)}  >
                                    <Icon icon={`bxs:${row.isExpanded ? 'down' : 'up'}-arrow`} />
                                    {"    "}
                                    {row?.original?.request?.id || row?.original?.id}

                                </div>
                                :
                                <>
                                    {row?.original?.request?.id || row?.original?.id}

                                </>
                            :
                            setPrint ?
                                <div className='pointer' onClick={() => setPrint(row?.original?.request?.id || row?.original?.id, row.original.isAllowModel56)}>
                                    <Icon icon={`material-symbols:print-rounded`} /> {row?.original?.request?.id || row?.original?.id}
                                </div>
                                : row?.original?.request?.id || row?.original?.id
                    }
                </div >
                : t(msg || "no-request-number")}
        </>
    )
}